/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUpdateAttachmentDto } from './CreateUpdateAttachmentDto';
import {
    CreateUpdateAttachmentDtoFromJSON,
    CreateUpdateAttachmentDtoFromJSONTyped,
    CreateUpdateAttachmentDtoToJSON,
} from './CreateUpdateAttachmentDto';
import type { CreateUpdateContractDtoSignaturePosition } from './CreateUpdateContractDtoSignaturePosition';
import {
    CreateUpdateContractDtoSignaturePositionFromJSON,
    CreateUpdateContractDtoSignaturePositionFromJSONTyped,
    CreateUpdateContractDtoSignaturePositionToJSON,
} from './CreateUpdateContractDtoSignaturePosition';

/**
 * 
 * @export
 * @interface CreateUpdateContractDto
 */
export interface CreateUpdateContractDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateContractDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    status: CreateUpdateContractDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    additionalEmailContent: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    emailContent: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    contractorEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateContractDto
     */
    notSendAutomatically: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateContractDto
     */
    sentByHand: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    responsibleOwnerId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    authorizedOwnerId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateContractDto
     */
    active: boolean;
    /**
     * 
     * @type {CreateUpdateAttachmentDto}
     * @memberof CreateUpdateContractDto
     */
    attachment: CreateUpdateAttachmentDto;
    /**
     * 
     * @type {CreateUpdateContractDtoSignaturePosition}
     * @memberof CreateUpdateContractDto
     */
    signaturePosition?: CreateUpdateContractDtoSignaturePosition | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    reasonUnsigning: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateContractDto
     */
    signedOutsidePok: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateContractDto
     */
    tv: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateContractDto
     */
    replacedByContractId?: string;
}


/**
 * @export
 */
export const CreateUpdateContractDtoStatusEnum = {
    Entered: 'Entered',
    WaitingForSigning: 'WaitingForSigning',
    Signed: 'Signed',
    Unsigned: 'Unsigned',
    Sent: 'Sent'
} as const;
export type CreateUpdateContractDtoStatusEnum = typeof CreateUpdateContractDtoStatusEnum[keyof typeof CreateUpdateContractDtoStatusEnum];


/**
 * Check if a given object implements the CreateUpdateContractDto interface.
 */
export function instanceOfCreateUpdateContractDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "additionalEmailContent" in value;
    isInstance = isInstance && "emailContent" in value;
    isInstance = isInstance && "contractorEmail" in value;
    isInstance = isInstance && "notSendAutomatically" in value;
    isInstance = isInstance && "sentByHand" in value;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "responsibleOwnerId" in value;
    isInstance = isInstance && "authorizedOwnerId" in value;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "attachment" in value;
    isInstance = isInstance && "reasonUnsigning" in value;
    isInstance = isInstance && "signedOutsidePok" in value;
    isInstance = isInstance && "tv" in value;

    return isInstance;
}

export function CreateUpdateContractDtoFromJSON(json: any): CreateUpdateContractDto {
    return CreateUpdateContractDtoFromJSONTyped(json, false);
}

export function CreateUpdateContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateContractDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'systemNumber': json['systemNumber'],
        'number': json['number'],
        'amount': json['amount'],
        'status': json['status'],
        'additionalEmailContent': json['additionalEmailContent'],
        'emailContent': json['emailContent'],
        'contractorEmail': json['contractorEmail'],
        'notSendAutomatically': json['notSendAutomatically'],
        'sentByHand': json['sentByHand'],
        'projectId': json['projectId'],
        'responsibleOwnerId': json['responsibleOwnerId'],
        'authorizedOwnerId': json['authorizedOwnerId'],
        'clientId': json['clientId'],
        'active': json['active'],
        'attachment': CreateUpdateAttachmentDtoFromJSON(json['attachment']),
        'signaturePosition': !exists(json, 'signaturePosition') ? undefined : CreateUpdateContractDtoSignaturePositionFromJSON(json['signaturePosition']),
        'reasonUnsigning': json['reasonUnsigning'],
        'signedOutsidePok': json['signedOutsidePok'],
        'tv': json['tv'],
        'replacedByContractId': !exists(json, 'replacedByContractId') ? undefined : json['replacedByContractId'],
    };
}

export function CreateUpdateContractDtoToJSON(value?: CreateUpdateContractDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'systemNumber': value.systemNumber,
        'number': value.number,
        'amount': value.amount,
        'status': value.status,
        'additionalEmailContent': value.additionalEmailContent,
        'emailContent': value.emailContent,
        'contractorEmail': value.contractorEmail,
        'notSendAutomatically': value.notSendAutomatically,
        'sentByHand': value.sentByHand,
        'projectId': value.projectId,
        'responsibleOwnerId': value.responsibleOwnerId,
        'authorizedOwnerId': value.authorizedOwnerId,
        'clientId': value.clientId,
        'active': value.active,
        'attachment': CreateUpdateAttachmentDtoToJSON(value.attachment),
        'signaturePosition': CreateUpdateContractDtoSignaturePositionToJSON(value.signaturePosition),
        'reasonUnsigning': value.reasonUnsigning,
        'signedOutsidePok': value.signedOutsidePok,
        'tv': value.tv,
        'replacedByContractId': value.replacedByContractId,
    };
}

